import React from 'react';
import IMG_CONNECTION_LOCK from '../../../../assets/images/connection_lock_private_secure_sharing_icon.svg';
import IMG_SECTIGO_LOGO from '../../../../assets/images/sectigo_logo.png';

const Footer = () => (
  <div className="mt-2">
    <div className="flex justify-center items-center md:hidden mt-[56px]">
      <div className="font-medium text-base text-[#263952] leading-4 mr-2">Questions?</div>
      <div className="font-bold text-lg text-[#D82027]">
        <a className="no-underline text-[#D82027] cursor-pointer" href="tel:8888118798" target="_blank" rel="noreferrer">888-811-8798</a>
      </div>
    </div>
    <div className="mt-11 flex items-center justify-around md:justify-start">
      <div className="flex mr-9">
        <img src={IMG_CONNECTION_LOCK} alt="connection_lock" />
        <span className="ml-2 text-xs text-[#364456]">
          <strong>256-bit SSL</strong>
          {' '}
          protection
          {' '}
          <br />
          {' '}
          and strict encryption
        </span>
      </div>
      <img src={IMG_SECTIGO_LOGO} alt="sectigo_logo" />
    </div>
  </div>
);

export default Footer;
